/* tslint:disable */
/* eslint-disable */
/**
 * crm-screener-api
 * crm-screener-api
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { CreateLeadsBulkRequestDocumentsInner } from './CreateLeadsBulkRequestDocumentsInner';
import {
    CreateLeadsBulkRequestDocumentsInnerFromJSON,
    CreateLeadsBulkRequestDocumentsInnerFromJSONTyped,
    CreateLeadsBulkRequestDocumentsInnerToJSON,
    CreateLeadsBulkRequestDocumentsInnerToJSONTyped,
} from './CreateLeadsBulkRequestDocumentsInner';
import type { AdmissionStatus } from './AdmissionStatus';
import {
    AdmissionStatusFromJSON,
    AdmissionStatusFromJSONTyped,
    AdmissionStatusToJSON,
    AdmissionStatusToJSONTyped,
} from './AdmissionStatus';
import type { LeadAdmissionStatusInfo } from './LeadAdmissionStatusInfo';
import {
    LeadAdmissionStatusInfoFromJSON,
    LeadAdmissionStatusInfoFromJSONTyped,
    LeadAdmissionStatusInfoToJSON,
    LeadAdmissionStatusInfoToJSONTyped,
} from './LeadAdmissionStatusInfo';

/**
 * 
 * @export
 * @interface CreateLeadsBulkRequest
 */
export interface CreateLeadsBulkRequest {
    /**
     * 
     */
    first_name: string;
    /**
     * 
     */
    last_name: string;
    /**
     * 
     */
    dob?: string | null;
    /**
     * 
     */
    gender?: string | null;
    /**
     * 
     */
    lead_received_date: string;
    /**
     * 
     */
    facility_ids: Array<string>;
    /**
     * 
     */
    source_id: string;
    /**
     * 
     */
    source_contact_id?: string | null;
    /**
     * 
     */
    source_discharge_date?: string | null;
    /**
     * 
     * @deprecated
     */
    admission_status?: AdmissionStatus;
    /**
     * 
     */
    admission_status_info?: LeadAdmissionStatusInfo;
    /**
     * 
     */
    documents?: Array<CreateLeadsBulkRequestDocumentsInner>;
}



/**
 * Check if a given object implements the CreateLeadsBulkRequest interface.
 */
export function instanceOfCreateLeadsBulkRequest(value: object): value is CreateLeadsBulkRequest {
    if (!('first_name' in value) || value['first_name'] === undefined) return false;
    if (!('last_name' in value) || value['last_name'] === undefined) return false;
    if (!('lead_received_date' in value) || value['lead_received_date'] === undefined) return false;
    if (!('facility_ids' in value) || value['facility_ids'] === undefined) return false;
    if (!('source_id' in value) || value['source_id'] === undefined) return false;
    return true;
}

export function CreateLeadsBulkRequestFromJSON(json: any): CreateLeadsBulkRequest {
    return CreateLeadsBulkRequestFromJSONTyped(json, false);
}

export function CreateLeadsBulkRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): CreateLeadsBulkRequest {
    if (json == null) {
        return json;
    }
    return {
        
        'first_name': json['first_name'],
        'last_name': json['last_name'],
        'dob': json['dob'] === undefined ? undefined : json['dob'] === null ? null : json['dob'],
        'gender': json['gender'] === undefined ? undefined : json['gender'] === null ? null : json['gender'],
        'lead_received_date': json['lead_received_date'],
        'facility_ids': json['facility_ids'],
        'source_id': json['source_id'],
        'source_contact_id': json['source_contact_id'] === undefined ? undefined : json['source_contact_id'] === null ? null : json['source_contact_id'],
        'source_discharge_date': json['source_discharge_date'] === undefined ? undefined : json['source_discharge_date'] === null ? null : json['source_discharge_date'],
        'admission_status': json['admission_status'] == null ? undefined : AdmissionStatusFromJSON(json['admission_status']),
        'admission_status_info': json['admission_status_info'] == null ? undefined : LeadAdmissionStatusInfoFromJSON(json['admission_status_info']),
        'documents': json['documents'] == null ? undefined : ((json['documents'] as Array<any>).map(CreateLeadsBulkRequestDocumentsInnerFromJSON)),
    };
}

export function CreateLeadsBulkRequestToJSON(json: any): CreateLeadsBulkRequest {
    return CreateLeadsBulkRequestToJSONTyped(json, false);
}

export function CreateLeadsBulkRequestToJSONTyped(value?: CreateLeadsBulkRequest | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'first_name': value['first_name'],
        'last_name': value['last_name'],
        'dob': value['dob'],
        'gender': value['gender'],
        'lead_received_date': value['lead_received_date'],
        'facility_ids': value['facility_ids'],
        'source_id': value['source_id'],
        'source_contact_id': value['source_contact_id'],
        'source_discharge_date': value['source_discharge_date'],
        'admission_status': AdmissionStatusToJSON(value['admission_status']),
        'admission_status_info': LeadAdmissionStatusInfoToJSON(value['admission_status_info']),
        'documents': value['documents'] == null ? undefined : ((value['documents'] as Array<any>).map(CreateLeadsBulkRequestDocumentsInnerToJSON)),
    };
}

